// @ts-check
import RoleTooltip from "./tooltip.js";

RoleTooltip.define();
export default RoleTooltip;
export * from './tooltip.js';

/**
 * @type {import("./tooltip-globals.js")}
 */

